import Api from './Api';

const all = (payload) => {
    const path = '/resellers';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/reseller/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/reseller/update',
        method: 'PUT',
        data: payload
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/reseller/destroy/${payload.id}`,
    });
};

export default {
    all,
    store,
    update,
    destroy
};
